import React, { useState, useEffect } from 'react';

const TestimonialsAndBook = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      id: 1,
      title: "Great Work",
      text: "“I think Educrat is the best theme I ever seen this year. Amazing design, easy to customize and a design quality superlative account on its cloud platform for the optimized performance”",
      name: "Courtney Henry",
      role: "Web Designer",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80"
    },
    {
      id: 2,
      title: "Amazing Experience",
      text: "“The learning platform is incredibly intuitive and the instructors are top-notch. I've seen my skills improve dramatically in just a few weeks of using Educrat.”",
      name: "Ronald Richards",
      role: "President of Sales",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80"
    },
    {
      id: 3,
      title: "Transformative",
      text: "“As a nursing assistant, I needed flexible learning options. Educrat provided exactly that with high-quality content that I could access anytime, anywhere.”",
      name: "Annette Black",
      role: "Nursing Assistant",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80"
    }
  ];

  const stats = [
    { value: "9/10", description: "9/10 users reported better learning outcomes." },
    { value: "85%", description: "85% of students see their course through to completion" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextSlide = () => setCurrentSlide((p) => (p + 1) % testimonials.length);
  const prevSlide = () => setCurrentSlide((p) => (p - 1 + testimonials.length) % testimonials.length);
  const goToSlide = (i) => setCurrentSlide(i);

  const MAX_VISIBLE = 3;
  const getRel = (i) => (i - currentSlide + testimonials.length) % testimonials.length;

  return (
    <section className="py-10 sm:py-14 md:py-20 bg-dark-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
          
          {/* Gauche */}
          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
              Témoignages & Réserver
            </h2>
            <p className="text-gray-300 mb-8 text-sm sm:text-base">
              Découvrez ce que nos étudiants disent de leur expérience avec nos tuteurs experts et réservez votre place dès aujourd'hui !
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-10">
              {stats.map((stat, i) => (
                <div key={i} className="text-white">
                  <div className="text-2xl sm:text-3xl font-bold mb-2">{stat.value}</div>
                  <div className="text-gray-300 text-sm sm:text-base">{stat.description}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Droite */}
          <div className="w-full lg:w-1/2 mt-10 lg:mt-0">
            <div className="relative flex items-center justify-center" style={{ perspective: '1400px' }}>
              <div className="relative w-full max-w-[480px] sm:max-w-[520px] min-h-[360px] sm:min-h-[420px]">
                {testimonials.map((t, i) => {
                  const rel = getRel(i);
                  if (rel >= MAX_VISIBLE) return null;

                  const isActive = rel === 0;
                  const translateX = isActive ? 0 : 12 + (rel - 1) * 14;
                  const translateY = isActive ? 0 : -(12 + (rel - 1) * 14);
                  const scale = isActive ? 1 : 0.96 - (rel - 1) * 0.03;
                  const rotate = isActive ? 0 : (rel % 2 ? -1.2 : 1.2);
                  const opacity = isActive ? 1 : 0.9 - (rel - 1) * 0.2;
                  const zIndex = 40 - rel;

                  return (
                    <article
                      key={t.id}
                      className={`absolute inset-0 bg-white rounded-3xl border border-gray-100 shadow-xl px-6 sm:px-8 py-6 sm:py-8 transition-all duration-500 ease-in-out`}
                      style={{
                        zIndex,
                        opacity,
                        transform: `translate(${translateX}px, ${translateY}px) scale(${scale}) rotate(${rotate}deg)`,
                      }}
                    >
                      <div className="flex flex-col h-full">
                        <h4 className="text-base sm:text-lg font-extrabold text-dark-1 mb-3">{t.title}</h4>
                        <p className="text-gray-700 italic text-sm sm:text-base leading-relaxed">{t.text}</p>

                        <div className="mt-auto pt-6 flex items-center">
                          <img
                            src={t.image}
                            alt={t.name}
                            className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover mr-3 sm:mr-4"
                          />
                          <div>
                            <div className="font-semibold text-sm sm:text-base text-dark-1">{t.name}</div>
                            <div className="text-gray-600 text-xs sm:text-sm">{t.role}</div>
                          </div>
                        </div>
                      </div>
                    </article>
                  );
                })}

                {/* Navigation */}
                <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 flex items-center gap-2 sm:gap-3">
                  <button
                    onClick={prevSlide}
                    className="h-9 w-9 sm:h-10 sm:w-10 rounded-full bg-white/90 border border-gray-200 flex items-center justify-center shadow hover:shadow-lg transition"
                  >
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>

                  <div className="flex gap-2">
                    {testimonials.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => goToSlide(idx)}
                        className={`h-2 sm:h-2.5 rounded-full transition-all ${
                          currentSlide === idx ? 'w-5 sm:w-6 bg-white' : 'w-2 sm:w-2.5 bg-white/50'
                        }`}
                      />
                    ))}
                  </div>

                  <button
                    onClick={nextSlide}
                    className="h-9 w-9 sm:h-10 sm:w-10 rounded-full bg-white/90 border border-gray-200 flex items-center justify-center shadow hover:shadow-lg transition"
                  >
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TestimonialsAndBook;
